
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
@Component
export default class DateDropdown extends Vue {
  private isPopShow: boolean = false; // 隐藏日期选择器
  private selectedDate: string = ''; // 所选日期
  // 接收父组件的值
  @Prop() private label: any; // 输入框左侧文字
  @Prop() private title: any; // 下拉框title
  @Prop() private type: any; // 日期类型：年月日时分秒
  @Prop() private beginDate: any; // 最小日期
  @Prop() private maxDate: any; // 最大日期
  @Prop() private editVal: any; // 编辑的获取到的值
  @Prop() private required: any; // 是否为必填
  @Prop() private disabled: any; // 是否禁用
  public data() {
    return {
      currentDate: new Date(),
      minDate: this.beginDate || new Date(1900, 1, 1),
      selectedDate: this.editVal ? moment(this.editVal).format('YYYY-MM-DD') : '',
    };
  }

  @Watch('editVal')
  private onEditValChange() {
    if (this.editVal !== '') {
      this.selectedDate = moment(this.editVal).format('YYYY-MM-DD');
    } else {
      this.selectedDate = '';
    }
  }

  // 选定日期
  private confirm(value: any) {
    const timestamp = Date.parse(value);
    if (this.type === 'date') {
      this.selectedDate = moment(timestamp).format('YYYY-MM-DD');
    } else if (this.type === 'datetime') {
      this.selectedDate = moment(timestamp).format('YYYY-MM-DD HH:mm');
    } else if (this.type === 'time') {
      this.selectedDate = moment(timestamp).format('HH:mm');
    } else if (this.type === 'year-month') {
      this.selectedDate = moment(timestamp).format('YYYY-MM');
    }
    this.$emit('input', this.selectedDate);
    this.cancel();
  }
  // 隐藏弹框
  private cancel() {
    this.isPopShow = false;
  }
}
